import React from "react";
import Link from "next/link";

const Index = () => {
  return (
    <footer>
      <div className="container" style={{ display: "flex", flexWrap: "wrap" }}>
        <div className="col-12 col-lg-6">
          <p style={{ paddingTop: "20px" }} className="text-md-center text-lg-start">
            <a
              href="https://portal.ehawaii.gov/page/privacy-policy/"
              target="_blank"
            >
              Privacy Policy
            </a>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <a href="https://dlnr.hawaii.gov/dsp/" target="_blank">
              About DLNR/State Parks
            </a>
            &nbsp;&nbsp;|&nbsp;&nbsp;{" "}
            <Link href="/inquiry">
              <a>Inquiry</a>
            </Link>
          </p>
          <p className="text-md-center text-lg-start">
            Copyright &copy; {new Date().getFullYear()} Hawai'i State Parks. All
            Rights Reserved.
          </p>
        </div>
        <div className="col-12 col-lg-6 text-center text-lg-end" style={{ paddingTop: "10px" }}>
          <p>
            <a href="https://outdoor.hawaii.gov/" target="_blank"><img src="/images/outdoor-hawaii-logo.png" className="footerLogo outdoorLogo" alt="Explore Outdoor Hawaii logo" /></a>
            <a href="https://invest.hawaii.gov/made-in-hawaii/" target="_blank">
              <img src="/images/made_in_hawaii_logo.png" className="footerLogo" alt="Hawaii Made logo" />
            </a>
            <img src="/images/hawaii-state-parks-logo.png" className="footerLogo" alt="Hawaii State Parks logo" />
            <img
              src="/images/Seal_of_the_State_of_Hawaii.svg"
              alt="Seal of the State of Hawaii"
              className="footerLogo stateSeal"
            />
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Index;
